<template>
  <v-card v-if="payload" flat>
    <router-link :to="{ name: 'detail', params: { id: payload.graph_id } }" tag="div">
      <v-card-title class="font-weight-bold title black--text">{{ payload.graph_title }}</v-card-title>
    </router-link>
    <v-layout v-if="payload.graph_tags" row wrap>
      <v-flex xs12>
        <tag-bar :tags="payload.graph_tags.map(tag => tag.tag_name)" />
      </v-flex>
    </v-layout>
    <v-layout class="pt-3">
      <v-flex xs6>
        <router-link :to="{ name: 'detail', params: { id: payload.graph_id}}">
          <v-img :src="payload.xml_data_no_labels" />
        </router-link>
      </v-flex>
      <v-flex xs6>
        <v-card-text class="pl-3 pt-0">
          <span class="caption">{{ payload.created_date | datetimeFormatter }}</span><br>
          <span>{{ payload.user.twitter_name }}</span><span>(<a class="primary--text text--darken-1" :href="'https://twitter.com/' + payload.user.twitter_screen_name" target="_blank" rel="noopener noreferrer">@{{ payload.user.twitter_screen_name }}</a>)</span><br>
        </v-card-text>
        <v-layout row>
          <v-flex xs12>
            <v-card-text class="pl-3 pt-0">閲覧数: {{ payload.access_count }}回</v-card-text>
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex xs12>
            <v-card-text class="pl-3 pr-0 py-0"><heart :heart="payload.heart_count" :graphId="payload.graph_id" :is_login="$store.state.twitter_account.is_login" :is_favorite="payload.is_favorite" /></v-card-text>
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex xs12>
            <v-card-text class="pl-3 pr-0 py-0"><share :share="payload.used_count" /></v-card-text>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-layout row justify-center>
      <v-flex xs6>
        <v-card-actions>
          <v-btn color="primary" class="black--text editBtn" @click="clickEditButton">編集</v-btn>
        </v-card-actions>
      </v-flex>
      <v-flex xs6>
        <v-card-actions>
          <v-btn color="secondary" class="white--text deleteBtn" @click="clickDeleteButton">削除</v-btn>
        </v-card-actions>
      </v-flex>
    </v-layout>
  </v-card>
</template>

<script>
import TagBar from "@/components/TagBar.vue";
import Heart from "@/components/Heart.vue";
import Share from "@/components/Share.vue";

export default {
  props: {
    payload: {
      required: true
    }
  },
  components: {
    TagBar,
    Heart,
    Share
  },
  methods: {
    clickEditButton() {
      this.$emit('click-edit-button', this.payload.graph_id);
    },
    clickDeleteButton() {
      this.$emit('click-delete-button', this.payload.graph_id);
    }
  }
}
</script>

<style scoped>
.container {
  padding: 10px;
}
.editBtn {
  justify-content: start;
  margin: 0;
  min-width: 100%;
}
.deleteBtn {
  justify-content: start;
  margin: 0;
  min-width: 100%
}
</style>